import { GSItemList, defaultLayouts, defaultPadding, defaultBorders, useMediaQuery } from "golfstatus_react_components";
import PackageGroupLineItem from "../events/event/packages/package-group-line-item";
import { useTheme } from "../../hooks/themeHooks";
import { useSelector } from "react-redux";
import { selectPublicTournament } from "../../reducers/tournamentSlice";
import { usePermissions } from "../../hooks/permissionHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const AdditionalPagesWidget = () => {
  const items = [];

  const [,theme,getStyle] = useTheme()

  const { isTablet, isPhone } = useMediaQuery();

  const navigate = useGolfstatusNavigate()

  const tournament = useSelector(selectPublicTournament)

  const permissions = usePermissions()

  if (tournament?.tournamentRounds?.length > 0 && !permissions.hideCourseDetails) {
    items.push({
      title: "Rounds",
      description: "View All",
      route: "rounds",
    });
  }

  if (!permissions.hideRegistrants) {
    items.push({
      title: "Registrants",
      description: "View All",
      route: "registrants",
    });
  }

  if (!tournament?.tournamentPromotion?.hideLeaderboards) {
    items.push({
      title: "Leaderboards",
      description: "View All",
      route: "leaderboards",
    });
  }


  return (
    <GSItemList
      type="inline-grid medium-large-gap selectable"
      style={{ ...defaultLayouts.fullWidth }}
      gridColumns={isTablet() ? Math.min(2, items.length) : isPhone() ? 1 : items?.length ?? 3}
      items={items}
      itemSelected={(item) => {navigate(item.route)}}
      listItem={(item) => (
        <PackageGroupLineItem
        className="hover-outline"
          style={{
            ...defaultLayouts.fill,
            ...defaultPadding.xLargePad,
            ...defaultBorders.mediumLargeBorderRadius,
            ...getStyle(theme.surface),
          }}
          navigate={() => {
            navigate(item.route);
          }}
          sponsorshipType={item.title}
          icon={item.icon}
          description={item.description}
        />
      )}
    />
  );
}

export default AdditionalPagesWidget